export const CLASS_ROOT = 'govuk-radios'

export const ORIENTATION = ['horizontal', 'vertical'] as const

export type OrientationType = typeof ORIENTATION[number]
